import { Car, Users, Calendar, Clock } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const AboutSection = () => {
  const { t } = useLanguage();

  const stats = [
    { icon: Car, value: t.about.stats.cars, label: "Bilar / Cars" },
    { icon: Users, value: t.about.stats.employees, label: "Personal / Staff" },
    { icon: Calendar, value: t.about.stats.since, label: "Grundat / Founded" },
    { icon: Clock, value: t.about.stats.available, label: "Tillgänglig / Available" },
  ];

  return (
    <section id="om-oss" className="section-spacing bg-neutral-950/50" data-testid="about-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <span className="text-yellow-500 text-sm font-semibold tracking-widest uppercase mb-4 block">
              {t.about.title}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              {t.about.subtitle}
            </h2>
            
            <div className="space-y-6 text-neutral-300 text-lg leading-relaxed">
              <p>{t.about.story}</p>
              <p>{t.about.growth}</p>
              <p>{t.about.mission}</p>
            </div>
          </div>

          {/* Right - Stats */}
          <div>
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="glass-card rounded-2xl p-6 text-center"
                >
                  <div className="w-14 h-14 bg-yellow-500/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <stat.icon className="w-7 h-7 text-yellow-500" />
                  </div>
                  <p className="text-2xl lg:text-3xl font-bold text-white mb-1">
                    {stat.value}
                  </p>
                  <p className="text-neutral-500 text-sm">{stat.label}</p>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="mt-6 rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://taxinora.se/new_assets/img/car/ODY633.jpg"
                alt="Taxi Nora VW Caddy"
                className="w-full h-48 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
